const MANAGE_STORAGE_MESSAGE_TYPE = "ME_PAGE_MANAGE_STORAGE";

const getParentOrigin = (): string | null => {
    const meQrAddress = process.env.REACT_APP_MEQR_ADDRESS;
    if (!meQrAddress) return null;

    try {
        return new URL(meQrAddress).origin;
    } catch {
        return null;
    }
};

const webViewEventService = {
    isAvailable(): boolean {
        return window.parent !== window
            && new URLSearchParams(window.location.search).get("webView") === "true"
            && getParentOrigin() !== null;
    },

    manageStorage(): void {
        const parentOrigin = getParentOrigin();
        if (!parentOrigin) return;

        window.parent.postMessage({type: MANAGE_STORAGE_MESSAGE_TYPE}, parentOrigin);
    },
};

export default webViewEventService;
